module.exports = __webpack_public_path__ + "static/media/quieromibarrio2.3b0b4741.jpg";